export default "__VITE_ASSET__CXSsoWOs__"